import React from 'react';

import '../styles.css';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import infoIco from 'assets/images/i-circle.svg';
import { Button } from 'react-bootstrap';
import LoginService from 'pages/login/services/login.service';
import { toast } from 'react-toastify';
import { userStore } from 'store/UserStore';
import hidden from '../../../assets/images/hidden.png';
import eye from '../../../assets/images/eye.png';
import { clearSessionData } from 'utils';

interface PropsType {
  handleModal: any;
  isShow: boolean;
}

const ChangePassword: React.FC<PropsType> = ({ handleModal, isShow }) => {
  const [isLoading, setLoading] = React.useState(false);
  const [user, customer, userData] = userStore((state: any) => [
    state.user,
    state.customer,
    state.userData,
  ]);
  const [isShowOldPwd, setShowOldPwd] = React.useState(false);
  const [isShowNewPwd, setShowNewPwd] = React.useState(false);
  const [isShowCnfrmPwd, setShowCnfrmPwd] = React.useState(false);

  const changePassword = async (val) => {
    setLoading(true);
    try {
      const res: any =
        user.userType === 'B2B_CUSTOMER'
          ? await LoginService.entChangePassword(
              userData['cognito:username'],
              val.old_password,
              val.new_password
            )
          : await LoginService.changePassword(
              userData?.sub,
              val.old_password,
              val.new_password
            );
      if (res) {
        toast.success('Password reset successfuly.');
        const timeout = setTimeout(() => {
          setLoading(false);
          clearSessionData();
          return (window.location.href = '/signin');
        }, 2000);
      }
    } catch (err: any) {
      toast.error(err.message);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        onClick={() => handleModal(false)}
        className={`Backdrop 
        ${isShow ? 'BackdropActive' : ''}`}
      />
      <div
        className={`Sidebar ${isShow ? 'Open' : ''}`}
        style={{ width: '420px' }}
      >
        <div className='modal-header'>
          <h4 className='modal-title'>Change Password</h4>
          <span
            aria-hidden='true'
            className='Close'
            onClick={() => handleModal(false)}
          >
            &times;
          </span>
        </div>
        <div className='p-5'>
          <Formik
            initialValues={{
              old_password: '',
              new_password: '',
              confirm_password: '',
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setSubmitting(false);
              changePassword(values);
            }}
            validationSchema={Yup.object().shape({
              old_password: Yup.string().required('Old Password is required'),
              new_password: Yup.string().required('New Password is required'),
              confirm_password: Yup.string()
                .oneOf(
                  [Yup.ref('new_password'), null],
                  "Passwords do not match"
                )
                .required('Confirm Password is required'),
            })}
          >
            {({ isSubmitting, errors, touched }) => (
              <Form translate={undefined}>
                <div className='form-group mb-2'>
                  <label className='form-label'>Old Password</label>
                  {/*<Field type="password" placeholder="" name="old_password"  className='form-control'/>*/}
                  <div className='input-group mb-3'>
                    <Field
                      type={isShowOldPwd ? 'text' : 'password'}
                      placeholder=''
                      name='old_password'
                      style={{ position: 'unset' }}
                      className='form-control'
                      autocomplete='off'
                    />
                    <div
                      className='input-group-text'
                      id='basic-addon1'
                      style={{
                        border: '1px solid #ced4da',
                        borderLeft: '0px',
                        backgroundColor: 'white',
                        borderRadius: '0rem 0.25rem 0.25rem 0rem',
                      }}
                    >
                      <a href='#' onClick={() => setShowOldPwd(!isShowOldPwd)}>
                        <img
                          className='m-2'
                          style={{ width: '16px' }}
                          src={isShowOldPwd ? hidden : eye}
                          alt=''
                        />
                      </a>
                    </div>
                  </div>
                  <div className='error'>
                    {errors.old_password && touched.old_password && (
                      <small id='my-helper-text'>
                        <img src={infoIco} alt='' />
                        {errors.old_password}
                      </small>
                    )}
                  </div>
                </div>

                <div className='form-group mb-2'>
                  <label className='form-label'>New Password</label>
                  {/*<Field type="password" placeholder="" name="new_password" className='form-control' />*/}
                  <div className='input-group mb-3'>
                    <Field
                      type={isShowNewPwd ? 'text' : 'password'}
                      placeholder=''
                      name='new_password'
                      style={{ position: 'unset' }}
                      className='form-control'
                      autocomplete='off'
                    />
                    <div
                      className='input-group-text'
                      id='basic-addon1'
                      style={{
                        border: '1px solid #ced4da',
                        borderLeft: '0px',
                        backgroundColor: 'white',
                        borderRadius: '0rem 0.25rem 0.25rem 0rem',
                      }}
                    >
                      <a href='#' onClick={() => setShowNewPwd(!isShowNewPwd)}>
                        <img
                          className='m-2'
                          style={{ width: '16px' }}
                          src={isShowNewPwd ? hidden : eye}
                          alt=''
                        />
                      </a>
                    </div>
                  </div>
                  <div className='error'>
                    {errors.new_password && touched.new_password && (
                      <small id='my-helper-text'>
                        <img src={infoIco} alt='' />
                        {errors.new_password}
                      </small>
                    )}
                  </div>
                </div>

                <div className='form-group mb-2'>
                  <label className='form-label'>Confirm Password</label>
                  {/*<Field type="password" placeholder="" name="confirm_password" className='form-control' />*/}
                  <div className='input-group mb-3'>
                    <Field
                      type={isShowCnfrmPwd ? 'text' : 'password'}
                      placeholder=''
                      name='confirm_password'
                      style={{ position: 'unset' }}
                      className='form-control'
                      autocomplete='off'
                    />
                    <div
                      className='input-group-text'
                      id='basic-addon1'
                      style={{
                        border: '1px solid #ced4da',
                        borderLeft: '0px',
                        backgroundColor: 'white',
                        borderRadius: '0rem 0.25rem 0.25rem 0rem',
                      }}
                    >
                      <a
                        href='#'
                        onClick={() => setShowCnfrmPwd(!isShowCnfrmPwd)}
                      >
                        <img
                          className='m-2'
                          style={{ width: '16px' }}
                          src={isShowCnfrmPwd ? hidden : eye}
                          alt=''
                        />
                      </a>
                    </div>
                  </div>
                  <div className='error'>
                    {errors.confirm_password && touched.confirm_password && (
                      <small id='my-helper-text'>
                        <img src={infoIco} alt='' />
                        {errors.confirm_password}
                      </small>
                    )}
                  </div>
                </div>

                <Button
                  disabled={isLoading}
                  className='w-100 mt-3'
                  variant='primary'
                  type='submit'
                >
                  {!isLoading ? (
                    'Change'
                  ) : (
                    <div className='spinner-border text-white' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                  )}
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
